// 老师端- 活动管理 - 实践成绩汇总、实践进度
import services from '../assets/js/services'

export default {
  state: {
    activityInfo: null
  },
  getters: {
  },
  actions: {
    // 实践成绩汇总 - 成绩列表
    getSchoolActivitySummary (context, payload) {
      return services.getSchoolActivitySummary(payload).then(res => {
        return res;
      })
    },
    // 获取活动详情
    getSchoolActivityDetail (context, payload) {
        return services.getSchoolActivityDetail(payload).then(res => {
            if (res.code == '0000') {
                context.commit('setActivityDetails', {
                    'data': res.data ? res.data : {}
                })
            }
            return res;
        })
    },
  },
  mutations: {
    // 设置实践学期
    setActivityDetails (state, payload) {
      state.activityInfo = payload.data;
  },
  }
}